module.exports = __webpack_public_path__ + "assets/1afe62007adc120b9543633d34d7d4b9.svg";